export class MarketDataChartJSON {
    ChartJSON: any;
    marketData: {
        marketData: {
            graphType: any
        };
        numberOfResponse: any;
        userFilters: any;
    }
}

export class MarketData {
    questionId: string;
    methodOfOperationId: string;
    techDomainId: string;
    surveyId: any;
    industryId: any = [];
    itBudgetId: any = [];
    geographyId: any = [];
    lineOfBusinessId: any = [];
    countryId: any = [];
    employeeSizeId: any = [];
    jobTitleId: any = [];
    globalRevenueId: any = [];
}

export class AdminFilteredData {
    methodOfOperationId: string;
    questionId: string;
}


// WEBPACK FOOTER //
// ./src/app/feature/main/roles-shared/models/marketDataModel.ts